import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "main-container mt-8 !items-start !content-start" }
const _hoisted_2 = { class: "actions-row flex items-center justify-between col-start-1 col-end-13" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = { class: "relative hidden md:block" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Sektöre Göre Filtrele", -1)
const _hoisted_7 = { class: "relative hidden md:block" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Etikete Göre Filtrele", -1)
const _hoisted_10 = {
  key: 0,
  class: "relative hidden md:block"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "Toplu Etiket Ekle", -1)
const _hoisted_13 = { class: "flex items-center gap-4" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "flex col-start-1 col-end-13 w-full text-2xl text-gray-500" }
const _hoisted_16 = {
  key: 0,
  class: "filtered-industry-row mt-4 items-center flex flex-wrap gap-1 w-full col-start-1 col-end-13 gap-4"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", { class: "font-bold text-2xl" }, "Filtrelenen Sektörler: ", -1)
const _hoisted_18 = {
  key: 1,
  class: "filtered-tags-row mt-4 flex items-center flex-wrap gap-1 w-full col-start-1 col-end-13 gap-4"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h4", { class: "font-bold text-2xl" }, "Filtrelenen Etiketler ", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 2,
  class: "alt-table mobile-preserved fixed-column-1 border-collapse col-start-1 col-end-13 max-w-full"
}
const _hoisted_23 = { class: "w-[1rem]" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-2xl py-4 px-8 whitespace-nowrap text-left" }, " E-Mail Adresi ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-2xl py-4 px-8 whitespace-nowrap text-left" }, " Adı", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-2xl py-4 px-8 whitespace-nowrap text-left" }, " Soyadı", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-2xl py-4 px-8 whitespace-nowrap text-left" }, " Sektör ", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-2xl py-4 px-8 whitespace-nowrap text-left scrolling-table-field" }, " Etiketler ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-2xl py-4 px-8 whitespace-nowrap text-left" }, " Şirket ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-2xl py-4 px-8 whitespace-nowrap text-left" }, " Telefon ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("th", { class: "font-bold text-2xl py-4 px-8 whitespace-nowrap text-left" }, " İşlemler", -1)

import firebase from "../../firebase"
import { computed, ref, onBeforeMount, onBeforeUnmount } from "vue";
import { modalClosed } from "../../mixins/visualFormatters";
import { useMultiSelectEMails,  exportEmailsToCSV, exportEmailsToExcel, addTagToMultipleEMails, resetSelectedEMails, massImportEmails, useGetAllEmails } from "../../composables/crmBasedFunctions"
import { useGetAllMetas, addOrUpdateMeta } from "../../mixins/metaManagement";
import { PotentialEMail, EMailTag, AcPotential } from "@/types/crm";
import { postData } from "../../mixins/modularFirebaseOperations";
import { useLocalPagination, formatUser  } from "../../mixins/visualFormatters";
import { updateSingleField, addSingleArrayItem, removeSingleArrayItem } from "../../mixins/modularFirebaseOperations";
import { useRouter } from 'vue-router';
import { useStore } from "vuex";
import resetBackground from "@/mixins/resetBackground";
import removeBackground from "@/mixins/removeBackground";
import mailImporter from "../crm-components/mailImporter.vue"
import EMailRow from "../crm-components/EMailRow.vue"
import addOrUpdateEmail from "../crm-components/addOrUpdateEmail.vue";
import listSearch from "../reusable/listSearch.vue";
import acPagination from "../reusable/acPagination.vue";
import filterPopup from "../reusable/filterPopup.vue";
import tagViewer from "../reusable/tagViewer.vue";
import acContextMenu from "../reusable/acContextMenu.vue";
import acMediumModal from "../reusable/teleports/acMediumModal.vue";
import statusChanger from "../reusable/statusChanger.vue";
import addPotentialFromEmail from "../crm-components/addPotentialFromEmail.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'EMailList',
  setup(__props) {

const { emailList, isLoadingEmails } = useGetAllEmails()

/* eslint-disable no-unused-vars */
const { metaList, isLoadingMetas } = useGetAllMetas("crm/EMailTags")

const isAddingEmail = ref<boolean>(false);
const isDisplayingMenu = ref<boolean>(false);
const editedEmail = ref<PotentialEMail | undefined>(undefined);
const currentTagToggledEmail = ref<string | undefined>(undefined)
const potentialEmail = ref<PotentialEMail | undefined>(undefined) // To create a potential from a contact info.
const isImporting = ref<boolean>(false);
const isMassAddingTags = ref<boolean>(false);
const router = useRouter()
const store = useStore()
const userProfile = computed(() => store.getters["user/userProfile"])
const userName = computed(() => store.getters["user/userProfile"].name)
// Searching and filtering:

const searchTerm = ref<string>("")
const isFilteringByIndustry = ref<boolean>(false)
const isFilteringByTag = ref(false)
const industriesFilter = ref<string[]>([])
const tagsFilter = ref<EMailTag[]>([])
const isTagFilterReversed = ref(false)

const industryList = computed(() => {
  const industries = emailList.value.map((email: PotentialEMail) => email.industry)
  return [...new Set(industries)]
})

const { selectedEMails } = useMultiSelectEMails()

const isMassSelected = ref(false)

const handleMassSelect = () => {
        if(isMassSelected.value){
            selectedEMails.value = emailList.value.map(mail => mail.id)
        }
        else{
            selectedEMails.value = []
        }
    }

const filteredEMails = computed(() => {

    let filteredResult = [...emailList.value]
    // Filter by the search term according to the name, industry, description, firstName, lastName

    if (searchTerm.value) {
        filteredResult = filteredResult.filter((EMail: PotentialEMail) => {
            return (
                EMail.email?.toLowerCase().includes(searchTerm.value.toLowerCase()) ||
                EMail.industry?.toLowerCase().includes(searchTerm.value.toLowerCase()) ||
                EMail.company?.toLowerCase().includes(searchTerm.value.toLowerCase()) ||
                EMail.desc?.toLowerCase().includes(searchTerm.value.toLowerCase()) ||
                EMail.firstName?.toLowerCase().includes(searchTerm.value.toLowerCase()) ||
                EMail.lastName?.toLowerCase().includes(searchTerm.value.toLowerCase())
            );
        });
    }

    if(industriesFilter.value.length > 0){
        filteredResult = filteredResult.filter(filterByIndustry)
    }

    if(tagsFilter.value.length > 0){
        filteredResult = filteredResult.filter(filterByTags)
    }

  // If userFiltered.value is false or undefined, return the original array
    return filteredResult;
});

// Pagination:

const { currentPage, totalPages, paginatedItems, setPage, nextPage, previousPage } = useLocalPagination(filteredEMails, 30)


function filterByIndustry(EMail: PotentialEMail){
    if(industriesFilter.value){
        return industriesFilter.value.includes(EMail.industry)
    }
}

function filterByTags(EMail: PotentialEMail) {
    if (!tagsFilter.value || tagsFilter.value.length === 0) {
        return true;
    }

    else if (isTagFilterReversed.value) {
        return !tagsFilter.value.some((tag: EMailTag) => {
            return EMail.tags?.some((EMailTag: EMailTag) => EMailTag.id === tag.id) ?? false;
        });
    }

    return tagsFilter.value.some((tag: EMailTag) => {
        return EMail.tags?.some((EMailTag: EMailTag) => EMailTag.id === tag.id) ?? false;
    });
}

const cancelSubmission = () => {
  isAddingEmail.value = false;
  editedEmail.value = undefined;
  modalClosed()
};

const handleSubmission = async (emailInformation: PotentialEMail) => {
  try {
    if (editedEmail.value) {
      await addOrUpdateMeta("crm/sales/EMailList", emailInformation, editedEmail.value.id)
      const index = emailList.value.findIndex((email: PotentialEMail) => email.id === editedEmail.value?.id)
      emailList.value[index] = {
        ...emailInformation,
        id: editedEmail.value.id
      }
    } else {
      // Check if the email already exists in the database
      const query = firebase.firestore().collection("crm/sales/EMailList").where("email", "==", emailInformation.email)
      const queryResult = query.get().then((querySnapshot) => {
        if (querySnapshot.size > 0) {
          throw new Error("Bu e-posta adresi zaten kayıtlı.");
        }
      })

      const newEmailId = await addOrUpdateMeta("crm/sales/EMailList", emailInformation)
        emailList.value.unshift({
          ...emailInformation,
          id: newEmailId
        })
    }
  } catch (error) {
    alert(`E-Mail bilgileri kaydedilirken bir hata oluştu: ${error}`)
  }
  isAddingEmail.value = false;
  editedEmail.value = undefined;
  modalClosed()

}

// Handle the update of a single field on the table

const handleSingleFieldUpdate = async (event: {field: string, value: string}, id: string) => {
  const field = event["field"],
  newValue = event["value"]
  try {
    await updateSingleField(`crm/sales/EMailList/${id}`, field, newValue)
    const index = emailList.value.findIndex((email: PotentialEMail) => email.id === id)
    emailList.value[index][field] = newValue
  } catch (error) {
    alert(`E-Mail bilgileri kaydedilirken bir hata oluştu: ${error}`) 
  } 

}

// Add tags from the email directly on the table

const handleAddTag = async (tag: EMailTag, emailId: string) => {
  try {
    await addSingleArrayItem(`crm/sales/EMailList/${emailId}`, "tags", tag);
    const index = emailList.value.findIndex((email: PotentialEMail) => email.id === emailId);
    
    if (index === -1) {
      throw new Error("Edited email not found in the list.");
    }

    emailList.value[index].tags?.push(tag);
  } catch (error) {
    alert(`E-Mail bilgileri kaydedilirken bir hata oluştu: ${error.message || error}`); 
  }
}

// Remove tags from the email directly on the table

const handleDeleteTagFromEmail = async (tag: EMailTag, emailId: string) => {
  try {
    await removeSingleArrayItem(`crm/sales/EMailList/${emailId}`, "tags", tag);
    const index = emailList.value.findIndex((email: PotentialEMail) => email.id === emailId);
    
    if (index === -1) {
      throw new Error("Edited email not found in the list.");
    }

    const tagIndex = emailList.value[index]?.tags?.findIndex((localTag: EMailTag) => localTag.id === tag.id);
    
    if (tagIndex === -1) {
      throw new Error("Tag not found in the email.");
    }

    emailList.value[index].tags?.splice(tagIndex, 1);
  } catch (error) {
    alert(`E-Mail bilgileri kaydedilirken bir hata oluştu: ${error.message || error}`); 
  }
}
// Filter by industry and tags

const addToFilterArray = (targetArray, item: string) => {
    if(targetArray.includes(item)){
        targetArray.splice(targetArray.indexOf(item), 1)
    } else {
        targetArray.push(item)
    }
    isFilteringByIndustry.value = false
    isFilteringByTag.value = false
}

// Handle mass import of emails

const handleImport = async (fileAndTags) => {
  const file = fileAndTags.file
  const tags = fileAndTags.tags
  await massImportEmails(file, tags, emailList.value, userName.value)

  // Without this timeout, the Firebase operation fails. We need to check this for larger data.

  setTimeout(() => {
    isImporting.value = false
    alert("İçe aktarım başarıyla tamamlandı.")
    window.location.reload()
  }, 1000)
}

// Handle mass adding of tags

const handleMassAddTag = async (tag: EMailTag) => {
  await addTagToMultipleEMails(tag, emailList.value); 
  resetSelectedEMails()
}

// Select the emails that are currently added to the selection by their ids.

const getSelectedEmails = () => {
  return emailList.value.filter((email: PotentialEMail) => selectedEMails.value.includes(email.id))
}

const handlePotentialCreated = async (newPotential: AcPotential) => {
    const potential = {
      ...newPotential,
      createdAt: new Date(),
      updatedAt: {
        date: new Date(),
        user: formatUser(userProfile.value),
      },
      addedBy: formatUser(userProfile.value),
      description: "",
      status: "ACTIVE",
      assignedTo: [formatUser(userProfile.value)],
      comments: [],
      referredBy: formatUser(userProfile.value),
      thirdPartyRefferrer: "",
      potentialCategories: [],
    }
    try{
    const id = await postData(potential, "crm/potentials/list")
    router.push(`/crm/potential-detail/${id}`)

    } catch (error) {
      console.error(error)
    } finally {
      potentialEmail.value = undefined
      modalClosed()
    }
}

// Create the context menu for importing and exporting

const emailsContextMenu = computed(() => {
  const staticItems = [
    {name: "Etiketleri Düzenle", action: () => {
      router.push("/crm/email-tags")
    }},
    {name: "İçe Aktarım Excel'ini İndir", action: () => {window.open("https://docs.google.com/spreadsheets/d/1Oyj5fbXSGXbfsjKoMUYiWgsOuZdA-zBL/edit?usp=sharing&ouid=103776557649670381330&rtpof=true&sd=true", "_blank")}},
    {name: "İçe Aktar", action: () => {isImporting.value = true}},
    ]

    // Single e-mail selected menu

    const singleEmailItems =[
      {name: "Potansiyel Oluştur", action: () => potentialEmail.value = getSelectedEmails()[0]}
    ]

    const massExportItems = [
    {name: "CSV Olarak Dışa Aktar", action: () => exportEmailsToCSV(filteredEMails.value)},
    {name: "Excel Olarak Dışa Aktar", action: () => {exportEmailsToExcel(filteredEMails.value)}},
    ]

    const selectedExportItems = [
    {name: "Seçimi CSV Olarak Dışa Aktar", action: () => exportEmailsToCSV(getSelectedEmails())},
    {name: "Seçimi Excel Olarak Dışa Aktar", action: () => {exportEmailsToExcel(getSelectedEmails())}},
    ]

    if(selectedEMails.value.length === 1){
        return [...staticItems, ...singleEmailItems]
    } else if(selectedEMails.value.length > 1){
        return [...staticItems, ...selectedExportItems]
    } else {
        return [...staticItems, ...massExportItems]
    }
  
})

onBeforeMount(() => {
  removeBackground.methods.removeBackground()

})

onBeforeUnmount(() => {
  resetBackground.methods.resetBackground()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(listSearch, {
          onSearchTermChanged: _cache[0] || (_cache[0] = ($event: any) => (searchTerm.value = $event))
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isFilteringByIndustry.value = true), ["stop"])),
            class: "ac-add-button"
          }, [
            _createElementVNode("img", {
              class: _normalizeClass({'filter-white': isFilteringByIndustry.value}),
              src: require('../../assets/icons/filter.png'),
              alt: "Filtrele"
            }, null, 10, _hoisted_5),
            _hoisted_6
          ]),
          (isFilteringByIndustry.value)
            ? (_openBlock(), _createBlock(filterPopup, {
                key: 0,
                onFilterClosed: _cache[2] || (_cache[2] = ($event: any) => (isFilteringByIndustry.value = false)),
                onFilterReset: _cache[3] || (_cache[3] = ($event: any) => (industriesFilter.value = [])),
                onItemSelected: _cache[4] || (_cache[4] = ($event: any) => (addToFilterArray(industriesFilter.value, $event))),
                "select-multiple": true,
                "selected-items": industriesFilter.value,
                class: "absolute w-full",
                itemList: industryList.value,
                "displayed-attribute": "name"
              }, null, 8, ["selected-items", "itemList"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (isFilteringByTag.value = true), ["stop"])),
            class: "ac-add-button"
          }, [
            _createElementVNode("img", {
              class: _normalizeClass({'filter-white': isFilteringByTag.value}),
              src: require('../../assets/icons/filter.png'),
              alt: "Filtrele"
            }, null, 10, _hoisted_8),
            _hoisted_9
          ]),
          (isFilteringByTag.value)
            ? (_openBlock(), _createBlock(statusChanger, {
                key: 0,
                "status-list": _unref(metaList),
                "displays-triangle": true,
                onUpdated: _cache[6] || (_cache[6] = ($event: any) => (addToFilterArray(tagsFilter.value, $event))),
                onCancelled: _cache[7] || (_cache[7] = ($event: any) => (isFilteringByTag.value = false)),
                title: "Etikete Göre Filtrele",
                class: "status-changer absolute w-[145%] top[95%] left-[0] !z-50"
              }, null, 8, ["status-list"]))
            : _createCommentVNode("", true)
        ]),
        (_unref(selectedEMails).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", {
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (isMassAddingTags.value = true), ["stop"])),
                class: "ac-add-button"
              }, [
                _createElementVNode("img", {
                  class: _normalizeClass({'filter-white': isMassAddingTags.value}),
                  src: require('../../assets/icons/filter.png'),
                  alt: "Filtrele"
                }, null, 10, _hoisted_11),
                _hoisted_12
              ]),
              (isMassAddingTags.value)
                ? (_openBlock(), _createBlock(statusChanger, {
                    key: 0,
                    "status-list": _unref(metaList),
                    "displays-triangle": true,
                    onUpdated: _cache[9] || (_cache[9] = ($event: any) => (handleMassAddTag($event))),
                    onCancelled: _cache[10] || (_cache[10] = ($event: any) => (isMassAddingTags.value = false)),
                    title: "Toplu Etiket Ekle",
                    class: "status-changer absolute !w-[20vw] top-[85%] left-[-25%] !z-50"
                  }, null, 8, ["status-list"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          class: "bg-white whitespace-nowrap border px-4 py-3 rounded-xl text-2xl flex items-center",
          onClick: _cache[11] || (_cache[11] = ($event: any) => {editedEmail.value = undefined; isAddingEmail.value = true})
        }, [
          _createElementVNode("img", {
            class: "mr-4",
            width: "20",
            src: require('../../assets/icons/add.png'),
            alt: ""
          }, null, 8, _hoisted_14),
          _createTextVNode(" Yeni Ekle ")
        ]),
        _createElementVNode("div", {
          onClick: _cache[12] || (_cache[12] = ($event: any) => (isDisplayingMenu.value = !isDisplayingMenu.value)),
          class: "bg-white whitespace-nowrap border px-4 py-3 rounded-xl text-2xl flex items-center relative"
        }, "İşlemler"),
        _createVNode(_Transition, {
          "enter-active-class": "animate__animated animate__fadeIn animate__fast",
          "leave-active-class": "animate__animated animate__fadeOut animate__fast"
        }, {
          default: _withCtx(() => [
            (isDisplayingMenu.value)
              ? (_openBlock(), _createBlock(acContextMenu, {
                  key: 0,
                  class: "absolute bg-white !top-8 !outline-none !right-0 mt-6",
                  items: emailsContextMenu.value,
                  onMenuDone: _cache[13] || (_cache[13] = ($event: any) => (isDisplayingMenu.value = false))
                }, null, 8, ["items"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_15, " Toplam " + _toDisplayString(filteredEMails.value.length) + " adet kontakt bulundu. ", 1),
    (industriesFilter.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _hoisted_17,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industriesFilter.value, (industry) => {
            return (_openBlock(), _createElementBlock("p", {
              class: "text-2xl",
              key: industry
            }, _toDisplayString(industry), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (tagsFilter.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _hoisted_19,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagsFilter.value, (tag) => {
            return (_openBlock(), _createBlock(tagViewer, {
              removable: true,
              onDeleteTag: _cache[14] || (_cache[14] = ($event: any) => (addToFilterArray(tagsFilter.value, $event))),
              key: tag.id,
              tag: tag
            }, null, 8, ["tag"]))
          }), 128)),
          _createElementVNode("button", {
            onClick: _cache[15] || (_cache[15] = ($event: any) => (isTagFilterReversed.value = !isTagFilterReversed.value)),
            class: "ac-secondary-button text-xl ml-auto"
          }, [
            (isTagFilterReversed.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Seçili Etiketleri Kullan"))
              : (_openBlock(), _createElementBlock("span", _hoisted_21, "Seçili Etiketleri Hariç Tut"))
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(isLoadingEmails))
      ? (_openBlock(), _createElementBlock("table", _hoisted_22, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((isMassSelected).value = $event)),
                  onChange: handleMassSelect,
                  type: "checkbox",
                  class: "table-checkbox !w-4"
                }, null, 544), [
                  [_vModelCheckbox, isMassSelected.value]
                ])
              ]),
              _hoisted_24,
              _hoisted_25,
              _hoisted_26,
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _hoisted_30,
              _hoisted_31
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginatedItems), (email) => {
              return (_openBlock(), _createBlock(EMailRow, {
                key: email.id,
                email: email,
                "current-toggled-e-mail": currentTagToggledEmail.value,
                tagList: _unref(metaList),
                onTagAdded: ($event: any) => (handleAddTag($event, email.id)),
                onTagDeleted: ($event: any) => (handleDeleteTagFromEmail($event, email.id)),
                onEdit: _cache[17] || (_cache[17] = ($event: any) => (editedEmail.value = $event)),
                onSingleFieldUpdate: ($event: any) => (handleSingleFieldUpdate($event, email.id))
              }, null, 8, ["email", "current-toggled-e-mail", "tagList", "onTagAdded", "onTagDeleted", "onSingleFieldUpdate"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(acPagination, {
      class: "w-full mx-auto col-start-1 col-end-13 flex flex-col items-center mb-8",
      "current-page": _unref(currentPage),
      "total-pages": _unref(totalPages),
      onNavigateToPage: _unref(setPage)
    }, null, 8, ["current-page", "total-pages", "onNavigateToPage"]),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (potentialEmail.value)
            ? (_openBlock(), _createBlock(acMediumModal, {
                key: 0,
                class: "lg:!top-44",
                onModalClosed: _cache[20] || (_cache[20] = ($event: any) => (potentialEmail.value = undefined)),
                height: "auto",
                width: "50vw",
                title: "Potansiyel Oluştur"
              }, {
                default: _withCtx(() => [
                  _createVNode(addPotentialFromEmail, {
                    onPotentialAdded: _cache[18] || (_cache[18] = ($event: any) => (handlePotentialCreated($event))),
                    onCancelled: _cache[19] || (_cache[19] = ($event: any) => (potentialEmail.value = undefined)),
                    email: potentialEmail.value
                  }, null, 8, ["email"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isAddingEmail.value || editedEmail.value)
            ? (_openBlock(), _createBlock(acMediumModal, {
                key: 0,
                class: "lg:!top-[4%]",
                onModalClosed: _cache[22] || (_cache[22] = ($event: any) => {isAddingEmail.value = false; editedEmail.value = undefined}),
                height: "auto",
                width: "50vw",
                title: "E-Posta Düzenle"
              }, {
                default: _withCtx(() => [
                  _createVNode(addOrUpdateEmail, {
                    onCancel: cancelSubmission,
                    onSubmitted: _cache[21] || (_cache[21] = ($event: any) => (handleSubmission($event))),
                    tags: _unref(metaList),
                    existingEMail: editedEmail.value,
                    onFormSubmitted: handleSubmission
                  }, null, 8, ["tags", "existingEMail"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])),
    (_openBlock(), _createBlock(_Teleport, { to: "#app" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isImporting.value)
            ? (_openBlock(), _createBlock(acMediumModal, {
                key: 0,
                class: "lg:!top-44",
                onModalClosed: _cache[25] || (_cache[25] = ($event: any) => (isImporting.value = false)),
                height: "auto",
                width: "50vw",
                title: "İçe Aktar"
              }, {
                default: _withCtx(() => [
                  _createVNode(mailImporter, {
                    onInitiateImport: _cache[23] || (_cache[23] = ($event: any) => (handleImport($event))),
                    onCancelled: _cache[24] || (_cache[24] = ($event: any) => {isImporting.value = false; _unref(modalClosed)()})
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})